import React, { Fragment } from 'react'
import { photos } from "../../constants/images"
export default function PublicLayout({ children }) {
    return (
        <Fragment>
            <div className="public-layout" >
                {children}
                {/* <div className="row">
                    <div className="col-sm-12 col-md-7 col-lg-7">
                        <div className="public-layout__center pt-30 pb-30 pl-20 pr-20 mt-20">
                            <img src={photos.logo} />
                            <h2>Welcome to GBM KIOSK Management</h2>
                        </div>
                    </div>
                    <div className="col-sm-12 col-md-5 col-lg-5" >
                        <div className="public-layout__height  pb-30 pl-10 pr-10" >
                            {children}
                        </div>
                    </div>
                </div> */}
            </div>
        </Fragment>
    )
}
